import { component$ } from '@builder.io/qwik';
import SportradarFactory from '~/components/Shared/Sportradar/SportradarFactory';
import type { SportradarBlockInterface } from '~/types/AppData/PageBuilder/SportradarBlockInterface';
import ScoreTicker from '~/components/Shared/Sportradar/ScoreTicker';

export default component$<SportradarBlockInterface['props']>(
  ({ name, sportradarProps, html }) => {
    // Score Ticker is a special case, with onclick event and different styles
    if (name.includes('scoreTicker')) {
      return <ScoreTicker html={html} />;
    }

    return (
      <SportradarFactory
        name={name}
        sportradarProps={sportradarProps}
        html={html}
      />
    );
  }
);
